import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Cover from './Components/Cover';
import PANDetails from './Components/PANDetails';
import MobileDetails from './Components/MobileDetails';
import CompanySearch from './Components/CompanySearch';
import CINResults from './Components/CINResults';
import AlternateMobileData from './Components/AlternateMobileData';
import styles from './kyc-intelligence.module.css';

function KYCIntelligence() {
    const requestId = useParams().requestId;
    const [dataFound, setDataFound] = useState(false);
    const [companySearch, setCompanySearch] = useState('');
    const [mobileResults, setMobileResults] = useState('');
    const [panResults, setPanResults] = useState('');
    const [cinResults, setCinResults] = useState('');
    const [alternateMobileData, setAlternateMobileData] = useState('');

    const fetchFunction = () => {
        axios.post(`${process.env.REACT_APP_PUBLIC_CONFIG_URL}/get-kyc-invincible-intelligence`, {
            requestId: requestId
        })
        .then((res) => {
            if(res.data.code===200) {
                setDataFound(true);
                setCompanySearch(res.data.result.data.companySearch);
                setMobileResults(res.data.result.data.mobileResults);
                setPanResults(res.data.result.data.panResults);
                setCinResults(res.data.result.data.cinResults);
                setAlternateMobileData(res.data.result.data.alternateMobileData);
            }
        })
        .catch((err) => {
            console.error(err);
        })
    };

    useEffect(() => {
        fetchFunction();
    }, [requestId]);

    return (<>
            {
                dataFound
                ?<>
                    <div className={styles['kyc-intelligence-report']}>
                        <Cover />
                        <div className={styles['report-header']}>
                            <img src="../images/alverezandmarsal-logo.png" alt="logo-dark" />
                            <p>
                                &nbsp;
                                <span>Email : vbhartee@alvarezandmarsal.com | Phone no : +91 8450971550 | Website : alvarezandmarsal.com</span>
                            </p>
                        </div>
                        {panResults && <PANDetails details={panResults} />}
                        {mobileResults && <MobileDetails details={mobileResults} />}
                        {companySearch && <CompanySearch details={companySearch} />}
                        {cinResults && <CINResults details={cinResults} />}
                        {alternateMobileData && <AlternateMobileData details={alternateMobileData} />}
                        <div className={styles['report-footer']}>Disclaimer :This report only sets out information obtained from Alvarez and Marsal's AI Driven Background Check Solution and is issued on “as is where is” basis. No opinion is provided in respect of the corporate entities or individuals who are the subject of the report here in. This report does not constitute recommendations as to what action should be taken. Thus while due care has been taken to ensure the accuracy of the compilation of information contained in this report, given the limitations of obtaining such information as noted above, no responsibility will be taken by Emptra for the consequences of relying upon info rmation contained in this report. All information supplied in this report is intended to be for the sole purpose of the client’s evaluation and is not intended for public dissemination.</div>
                    </div>
                </>
                :"No details found for this request ID."
            }
    </>);
}

export default KYCIntelligence;